import { Directive, ElementRef, HostListener, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[appTouchSelect]'
})
export class TouchSelectDirective {

  @Output() touchSelect = new EventEmitter<void>();

  constructor(private el: ElementRef) { }
  ngOnInit() {
    //console.log('TouchSelectDirective applied to', this.el.nativeElement);
  }
  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    setTimeout(() => {
      if (event.target && (event.target as HTMLElement).tagName === 'INPUT') {
        console.log('Input field touched, not preventing default');
      } else {
        event.preventDefault();
      }
      this.touchSelect.emit();
    }, 10);
  }
}
